module.exports = {
    english: "Englisch",
    slovak: "Slovakisch",
    deutsch: "Deutsch",
    log_in_via: "Einloggen über",
    log_in_using_local_account: "Melden Sie sich mit Ihrem lokalen konto an",
    per: "für",
    or: "ODER",
    user: "Benutzer",
    password: "Passwort",
    device: "Ausrüstung",
    status: "Zustand",
    action: "Aktion",
    imprint_id: "Fingerabdruck ID",
    name: "Name",
    brand: "Modell",
    description: "Bemerkung",
    timestamp: "Zaitstempel",
    uptime: "Online Zeit",
    firmware_version: "Softwareversion",
    appliance_on: "Das Gerät wurde eingeschaltet",
    appliance_off: "Das Gerät wurde ausgeschaltet",
    identification_success: "Identification success rate",
    duration: "Dauer",
    energy_consumption: "Energieverbrauch",
    minutes: "Minuten",
    and: "und",
    seconds: "Sekunden",
    are_you_sure: "Bist du sicher?",
    unknown: "unbekannte",
    merito_energy: "MeriTo Energie",
    last_change: "letzte Änderung",
    energy_relay: "Energie",
    in_seconds: "in Sekunden",
    test_profile: "Testprofil",
    relative_error: "Relativer Fehler",
    absolute_error: "Absoluter Fehler",
    test_value: "Testwert",
    no_device: "Keine Geräte",
    showing: "Zeigen",
    of: "von",
    rows: "Reihen",
    mac_address: "MAC-Adresse",
    none: "Keiner",
    static: "Statisch",
    detected_on: "Erkannt am",
    status_db_update: "Datenbank-Update",
    ws_icon_connected: "In Verbindung gebracht",
    ws_icon_not_connected: "Verbindungszeitüberschreitung"
}